<template>
  <div
    v-if="mappedIconClass"
    class="avatar_initial report-icon-avatar"
  >
    &nbsp;
    <div
      class="report-icon-avatar-icon"
      :class="[mappedIconClass]"
    ></div>
  </div>
  <ReportTableAvatarInitial
    v-else
    :text="text"
  />
</template>

<script>
import ReportTableAvatarInitial from '~/components/reports/ReportTableAvatarInitial.vue';

// map :iconKey to :icons, show icon if icons[iconKey] exist or fallback to ReportTableAvatarInitial
// http://app.hubstaff.test/dev/ReportTableAvatarIconInitial
export default {
  name: 'ReportTableAvatarIconInitial',
  components: { ReportTableAvatarInitial },
  props: {
    iconKey: {
      type: String,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    // Forwarded to ReportTableAvatarInitial.text
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    mappedIconClass() {
      return this.icons[this.iconKey];
    },
  },
};
</script>
